import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import VideoEmbedComponent from './VideoEmbedComponent';

// Stores only a reference (projectUuid + mediaUuid) to an uploaded video,
// never a playable url — see ResolvedVideo.tsx for why. Serializes as a
// <video data-media-uuid="..."> marker with no src; both the live editor
// (via the node view below) and the read-only comment renderer resolve a
// fresh short-lived url from that reference at render time.
export const VideoEmbed = Node.create({
  name: 'videoEmbed',

  group: 'block',

  atom: true,

  draggable: true,

  addAttributes() {
    return {
      mediaUuid: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-media-uuid'),
        renderHTML: (attributes) => ({ 'data-media-uuid': attributes.mediaUuid }),
      },
      projectUuid: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-project-uuid'),
        renderHTML: (attributes) => ({ 'data-project-uuid': attributes.projectUuid }),
      },
      fileName: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-filename'),
        renderHTML: (attributes) => (attributes.fileName ? { 'data-filename': attributes.fileName } : {}),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'video[data-media-uuid]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['video', mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(VideoEmbedComponent);
  },
});

export default VideoEmbed;
